import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as authSelector from "../../../../../store/selectors/authSelectors";
import { Title, P } from "../PolicyTerms/style";
import { TermsContainer } from "../../../CommonStyles";
import Checkbox from "../../../../common/Input/CheckBox/index";
import { useTranslation } from "react-i18next";
import { ButtonSmallWider } from "../../../../Errors/errorPageStyles";
import { colorBlack, colorYellow } from "../../../../../utils/css/colors";
import { Wrapper, Para } from "./PrivecyPolicyStyle";
import { Dialog } from "@material-ui/core";
import Layout from "../../../Layout";
import useLogout from "../../../../common/useLogout";
import { confirmPolicyRequest } from "../../../../../store/actions/auth/auth.action";

const PrivacyPolicyHeb: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const logout = useLogout();
  const id = useSelector(authSelector.idSelector);
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = () => {
    setIsChecked((prev) => !prev);
  };

  const handleConfirmed = () => {
    dispatch(confirmPolicyRequest(true, id));
  };

  return (
    <Layout>
      <Dialog open>
        <TermsContainer lngDirection="heb">
          <Title>הצהרה וכתב התחייבות</Title>

          <P>אני מצהיר/ה ומאשר/ת בזאת כדלקמן:</P>

          <P>
            פניתי אל עמותת "זכרון בסלון" (ע"ר) ("העמותה") בבקשה להתנדב בעמותה.
          </P>

          <P>
            התנדבותי נעשית מרצוני הטוב והחופשי ומתוך הזדהות עם פעילות העמותה
            ומטרותיה.
          </P>

          <P>
            התנדבותי נעשית ללא קבלת תמורה כספית או אחרת ,למעט החזר הוצאותיי, בין
            אם מהעמותה ו/או מצד ג 'כלשהו. אין ביני ובין העמותה הסכם עבודה ו/או
            כל הסכם אחר הנוגע לפעילותי במסגרת העמותה.
          </P>

          <P>
            התנדבותי תתבצע בימים ובשעות הנוחים לי ,כפי שאמסור לעמותה מפעם לפעם
            .לא התחייבתי לעמותה על תקופת התנדבות כלשהי ,או על ימים ושעות מוגדרים
            לביצוע התנדבותי, והנני רשאי/ת להפסיק את התנדבותי בכל עת וללא צורך
            בהודעה מראש.
          </P>

          <P>
            הוסבר לי כי אינני כפוף/ה למרותו של אף גורם בעמותה ,אלא אם מדובר
            בעניינים מקצועיים בהם עליי למלא אחר הוראות מקצועיות ,כפי שיינתנו לי
            על ידי הגורמים מוסמכים בעמותה, וזאת כתנאי להתנדבותי בתפקידים אלו
          </P>

          <P>
            אני מתחייב/ת להימנע מלעשות כל פעולה, בין במישרין או בעקיפין, במעשה
            או במחדל, שעלולה לפגוע בעמותה במהלך תקופת התנדבותי או לאחריה.
          </P>

          <P>
            אני מתחייב/ת להודיע לעמותה מיד על כל עניין או נושא שיש לי לגביהם
            עניין אישי ו/או עלולים ליצור ניגוד עניינים עם התנדבותי בעמותה, כולל
            פעילות פוליטית.
          </P>

          <P>
            ידוע לי שבמסגרת התנדבותי יגיעו לידי מידע ו/או נתונים בקשר עם העמותה
            ועל כן אני מתחייב לקיים את האמור בנספח להצהרתי זו בדבר שמירת סודיות.
          </P>

          <Para className="commitment">לכבוד</Para>
          <Para>זיכרון בסלון (ע"ר)</Para>
          <Para>מ"ז 580662070</Para>
          <Para>
            ("<b>העמותה</b>")
          </Para>

          <P>גא"נ,</P>

          <Para className="commitmentTitle">
            הנדון:<span> כתב התחייבות לשמירת סודיות</span>
          </Para>

          <Para className="commitment">
            <b className="bold">הואיל</b>
            ובמסגרת התנדבותי עבור העמותה, העמותה עשויה למסור לי מידע סודי
            (כהגדרתו להלן), בין בכתב, בין בעל-פה ובין בכל דרך אחרת.
          </Para>

          <Para className="commitmentTitle commitment">
            לפיכך, אני מאשר/ת ומתחייב/ת בזאת כדלקמן:
          </Para>

          <P>
            לצורכי כתב התחייבות זה, המונח <b>"מידע סודי"</b> פירושו, כל מידע או
            כל חלק ממנו, בין בכתב, בין בעל-פה, בין במדיה מגנטית או אופטית ובין
            בעזרת כל אמצעי אחר לאגירת מידע בקשר עם העמותה, בין אם בעל אופי טכני,
            עסקי או אחר, לרבות ומבלי לגרוע מכלליות האמור לעיל, קניין רוחני,
            סודות מסחר, נתונים אודות פעילות העמותה, שיטות ותהליכים אשר קשורים
            אליה ו/או לפעילותה, התקשרויות עם צדדים שלישיים – לרבות מידע סודי של
            גורם שלישי כלשהו המצוי אצל העמותה. המונח <b> "קניין רוחני" </b>{" "}
            פירושו, כל זכויות הקניין הרוחני, לרבות ידע, אמצאות, פטנטים, סודות
            מסחריים, סימני מסחר, שמות מסחריים, זכויות יוצרים ומדגמים, וכל רישיון
            וזכות ביחס לכל האמור לעיל, וכן ביחס לסודות מקצועיים, רעיונות,
            המצאות, פיתוחים, תכנונים, תהליכים, עבודות מקוריות, תוכנות מחשב,
            מערכות מסחר, אלגוריתמים, קוד מקור, מידע ונתונים טכניים, והכל בין אם
            רשומים ובין אם לאו.
          </P>

          <P>
            אני מתחייב/ת לשמור את המידע הסודי בסודיות מוחלטת ולא להעבירו לכל אדם
            או גוף, ולא לעשות בו, או בכל חלק ממנו, כל שימוש ישיר או עקיף, וכן לא
            למכור, למסור, לצלם, לשכפל, להקליט, לגלות, למסור ו/או להעביר את המידע
            הסודי בכל צורה ודרך שהיא, בין במישרין ובין בעקיפין, בין בישראל ובין
            מחוץ לתחומי ישראל, אלא לצורך התנדבותי עבור העמותה ("<b>המטרה</b>"),
            ובהינתן הסכמת העמותה מראש, והכל בכפוף לתנאי כתב התחייבות זה.
          </P>

          <P>
            אני מתחייב/ת בזאת להודיע לעמותה מייד וללא דיחוי על כל מקרה שבעקבותיו
            הועבר מידע סודי ו/או קיים חשש כי הועבר מידע סודי ו/או כי יועבר מידע
            סודי, לגורם כלשהו, בניגוד לאמור בכתב התחייבות זה.
          </P>

          <P>
            בכל מקרה בו אדרש, מכוח סמכות שבדין או על-פי הוראה של בית משפט מוסמך
            במסגרת הליך משפטי לגלות את המידע הסודי, כולו או חלקו, יינתן רק המידע
            המינימלי הנדרש כאמור ואני אודיע על כך לעמותה מיידית ובכתב בטרם אגלה
            את המידע, וזאת על מנת לאפשר לעמותה להתגונן מפני דרישה כאמור.
          </P>

          <P>
            התחייבויותיי כאמור לא תחולנה על מידע סודי אשר ביכולתי להוכיח שהוא:
            (א) נמצא ברשות הציבור או הגיע לרשות הציבור לאחר חתימתי על כתב
            התחייבות זה, שלא בגין הפרת התחייבות כלשהי מצדי; (ב) נמסר לי על-ידי
            צד שלישי, אשר אינו קשור לעמותה ואשר אינו חב כלפיה בחובת סודיות; (ג)
            פותח באופן עצמאי על-ידיי.
          </P>

          <P>
            אני אנקוט בכל אמצעי הזהירות הנחוצים כדי למנוע את חשיפת המידע הסודי
            או כל חלק ממנו לכל גורם, שאינו זכאי לכך על-פי תנאי כתב התחייבות זה,
            לפחות באותה מידת קפידה בה אני נוהג/ת במידע סודי השייך לי.
          </P>

          <P>
            אני מתחייב/ת להחזיר לעמותה, מיד עם דרישתה, כל מסמך, מפרט, שרטוט,
            טבלה, דוגמא, תכנית וכל נתונים רשומים אחרים אשר הגיעו אלי, בין
            במישרין ובין בעקיפין, וכן כל תעתיק ו/או שיכפול ו/או שעתוק ו/או שחזור
            בכל דרך שהיא, של כל או חלק מהמידע הסודי או של כל מידע אחר שהועבר
            ונמסר לי בקשר עם העמותה ו/או בנוגע למטרה.
          </P>

          <P>
            התחייבויותיי לשמירת סודיות ואי-שימוש במידע הסודי הכלולות בכתב
            התחייבות זה הן לתקופה בלתי מוגבלת ותמשכנה לחול עלי באופן מלא גם לאחר
            סיום ההתקשרות ביננו.
          </P>

          <P>
            אני מצהיר/ה ומאשר/ת, כי ידוע לי שכל הפרה של התחייבות על-פי כתב
            התחייבות זה עלולה לגרום לעמותה נזקים חמורים ובלתי הפיכים אשר אינם
            ברי תיקון מלא ושלם על-ידי פיצוי כספי. מבלי לגרוע מכל זכות או תרופה
            אחרת העומדת לזכות העמותה, אני מתחייב/ת כי לא אתנגד לכל צו מניעה אשר
            תבקש להוציא העמותה כנגדי על מנת למנוע או לתקן הפרה כאמור.
          </P>

          <P>
            אין באמור בכתב התחייבות זה, כדי להעניק לי כל זכויות קניין רוחני
            במידע הסודי, אשר יהיו בבעלותה הבלעדית של העמותה, ואני מוותר/ת בזאת
            במפורש כלפי העמותה על כל טענה ו/או דרישה ו/או תביעה שיש לי ו/או תהיה
            לי לגבי זכויות קניין רוחני כאמור.
          </P>

          <P>
            ידוע לי כי העמותה לא הציגה כל מצג או הצהרה בקשר עם נכונות ו/או שלמות
            המידע הסודי, וכי העמותה איננה אחראית כלפיי בגין כל שימוש או הסתמכות
            על המידע הסודי, כולו או חלקו. כמו כן, אין באמור בכתב התחייבות זה,
            כדי ליצור התחייבות של העמותה למסור או לגלות לי מידע סודי כאמור, וכן
            כדי ליצור התחייבות של העמותה להתקשר עמי לצורך המטרה, או בכלל.
          </P>

          <P>
            שום התנהגות מצד העמותה לא תיחשב כויתור על איזו מזכויותיה על-פי כתב
            התחייבות זה, או על-פי כל דין, או כהסכמה מצידה להפרה, או לאי-קיום של
            התחייבויותיי על-פי כתב התחייבות זה, או לשינוי תנאי מתנאי כתב
            התחייבות זה, אלא אם הויתור ו/או ההסכמה ו/או השינוי, נעשו במפורש בכתב
            ובחתימת העמותה.
          </P>

          <P>
            הדין החל על כתב התחייבות זה הוא דין מדינת ישראל בלבד. סמכות השיפוט
            הבלעדית בכל עניין הנוגע לכתב התחייבות זה תהא נתונה לבתי המשפט
            המוסמכים במחוז תל אביב, ולהם בלבד.
          </P>

          <Wrapper>
            <Checkbox
              label={t(`formButtons.i_confirm_reading_the_privecy_policy`)}
              checkboxKey="privecyConfirmationCheckbox"
              onChange={handleChange}
              isChecked={isChecked}
            />

            <button className="btn" onClick={logout}>
              {t("admin.cancel")}
            </button>

            <ButtonSmallWider
              isFontBold
              colorType={colorYellow}
              colorProps={colorBlack}
              width={7}
              isBold
              onClick={handleConfirmed}
              disabled={!isChecked}
              applyShadow
            >
              {t("formButtons.ok")}
            </ButtonSmallWider>
          </Wrapper>
        </TermsContainer>
      </Dialog>
    </Layout>
  );
};

export default PrivacyPolicyHeb;
